import moment from 'moment';

export const dateFormat = 'YYYY-MM-DD';
export const timeFormat = 'HH:mm';
export const dateTimeFormat = 'YYYY-MM-DD HH:mm';
export const dateTextMonthFormat = 'D MMMM YYYY';
export const dateTextMonthAndDayFormat = 'D MMMM';

export function getDate(value) {
  if (!moment(value).isValid()) {
    return undefined;
  }
  const convertedValue = moment(value);
  return convertedValue && value ? convertedValue.utc().toISOString() : undefined;
}

export function getDateWithoutTime(value) {
  if (!moment(value).isValid()) {
    return undefined;
  }
  const convertedValue = moment(value);
  return convertedValue && !isNullOrUndefiend(value) ? convertedValue.format(dateFormat) : undefined;
}

export function getTimeWithoutDate(value) {
  if (!moment(getTime(value)).isValid()) {
    return undefined;
  }
  const convertedValue = moment(getTime(value));
  return convertedValue && !isNullOrUndefiend(value) ? convertedValue.format(timeFormat) : undefined;
}

export function getTime(value) {
  if (typeof value === 'string' && value && value.length <= 5) {
    const date = moment();
    const splitValue = value.split(':');
    date.hours(splitValue[0]);
    date.minutes(splitValue[1]);
    return date.toISOString();
  } else if (typeof value === 'string' && value) {
    return value;
  } else if (value) {
    return moment(value).toISOString();
  }
  return undefined;
}

export function getMomentDateTime(value) {
  if (!moment(value).isValid()) {
    return undefined;
  }
  return value ? moment(value) : undefined;
}

export function getDateDateTime(value) {
  if (!moment(value).isValid()) {
    return undefined;
  }
  return value ? moment(value).toDate() : undefined;
}

export function getLocalDateTime(value) {
  if (!moment(value).isValid()) {
    return undefined;
  }
  return value ? moment(value).format(dateTimeFormat) : undefined;
}

export function dateToMoment(date) {
  if (!moment(date).isValid()) {
    return undefined;
  }
  return date ? moment(date) : undefined;
}

export function dateAndTimeToMoment(date, time) {
  const dateTime = date ? moment(date) : undefined;
  if (dateTime) {
    dateTime.startOf('day');
    if (time) {
      const momentTime = moment(time);
      dateTime.hours(momentTime.hours());
      dateTime.minutes(momentTime.minutes());
    }
  }
  return dateTime;
}

function isNullOrUndefiend(value) {
  if (value === null || value === undefined) {
    return true;
  }
}
